/*!
|--------------------------------------------------------------------------
| Amora Atmosphere Engine
|--------------------------------------------------------------------------
| Version: 2.0
| Author: ChatGPT
|--------------------------------------------------------------------------
|
| Supported Atmospheres
|
| sakura
| flower
| butterfly
| sparkle
| leaf
| snow
| heart
| dust
|
|--------------------------------------------------------------------------
*/

(() => {

"use strict";

/*==================================================
=            CONFIGURATION
==================================================*/

const CONFIG = {

    sakura: {
        particles: 45,
        gravity: 0.45,
        wind: 0.30,
        minSize: 8,
        maxSize: 18
    },

    flower: {
        particles: 28,
        gravity: 0.35,
        wind: 0.25,
        minSize: 10,
        maxSize: 20
    },

    butterfly: {
        particles: 14,
        gravity: 0.18,
        wind: 0.55,
        minSize: 18,
        maxSize: 28
    },

    sparkle: {
        particles: 70,
        gravity: 0.04,
        wind: 0.10,
        minSize: 3,
        maxSize: 8
    },

    leaf: {
        particles: 30,
        gravity: 0.40,
        wind: 0.50,
        minSize: 10,
        maxSize: 20
    },

    snow: {
        particles: 55,
        gravity: 0.18,
        wind: 0.18,
        minSize: 4,
        maxSize: 10
    },

    heart: {
        particles: 24,
        gravity: 0.30,
        wind: 0.15,
        minSize: 10,
        maxSize: 18
    },

    dust: {
        particles: 90,
        gravity: 0.01,
        wind: 0.05,
        minSize: 2,
        maxSize: 5
    }

};

/*==================================================
=            SHOPIFY
==================================================*/

const atmosphere =
window.amora?.atmosphere || "dust";

const settings =
CONFIG[atmosphere] || CONFIG.dust;

/*==================================================
=            PREVENT DOUBLE INIT
==================================================*/

if(document.getElementById("amora-atmosphere"))
    return;

/*==================================================
=            CANVAS
==================================================*/

const canvas =
document.createElement("canvas");

canvas.id = "amora-atmosphere";

Object.assign(canvas.style,{
    position:"fixed",
    inset:"0",
    width:"100%",
    height:"100%",
    pointerEvents:"none",
    zIndex:"9999"
});

document.body.appendChild(canvas);

const ctx =
canvas.getContext("2d");

/*==================================================
=            SIZE
==================================================*/

let width;
let height;
let DPR;

function resize(){

    DPR = window.devicePixelRatio || 1;

    width = window.innerWidth;
    height = window.innerHeight;

    canvas.width = width * DPR;
    canvas.height = height * DPR;

    canvas.style.width = width+"px";
    canvas.style.height = height+"px";

    ctx.setTransform(DPR,0,0,DPR,0,0);

}

resize();

window.addEventListener(
"resize",
resize
);

/*==================================================
=            REDUCED MOTION
==================================================*/

const reducedMotion =
window.matchMedia(
"(prefers-reduced-motion: reduce)"
).matches;

if(reducedMotion){

    console.log(
        "Reduced motion enabled."
    );

    return;

}

/*==================================================
=            VISIBILITY
==================================================*/

let paused = false;

document.addEventListener(
"visibilitychange",
()=>{

paused = document.hidden;

});



/*==================================================
=            MOUSE
==================================================*/

const mouse = {

    x:-1000,
    y:-1000,
    radius:120

};

window.addEventListener(
"mousemove",
e=>{

mouse.x=e.clientX;
mouse.y=e.clientY;

});

window.addEventListener(
"mouseleave",
()=>{

mouse.x=-1000;
mouse.y=-1000;

});

/*==================================================
=            WIND
==================================================*/

const wind = {

    strength:0,
    target:0,

    timer:0

};

function updateWind(time){

    if(time>wind.timer){

        wind.timer =
        time +
        random(4000,12000);

        wind.target =
        random(
            -settings.wind,
             settings.wind
        );

    }

    wind.strength +=
    (wind.target-wind.strength)
    *0.005;

}

/*==================================================
=            HELPERS
==================================================*/

function random(min,max){

    return Math.random()*
    (max-min)+min;

}

function clamp(v,min,max){

    return Math.min(
        Math.max(v,min),
        max
    );

}

function distance(x1,y1,x2,y2){

    return Math.hypot(
        x2-x1,
        y2-y1
    );

}

/*==================================================
=            PARTICLE
==================================================*/

class Particle{

    constructor(){

        this.reset(true);

    }

    reset(first=false){

        this.x =
        random(0,width);

        this.y =
        first
        ? random(0,height)
        : -40;

        this.size =
        random(
            settings.minSize,
            settings.maxSize
        );

        this.speedX =
        random(-0.3,0.3);

        this.speedY =
        random(
            settings.gravity,
            settings.gravity+1
        );

        this.rotation =
        random(0,360);

        this.rotationSpeed =
        random(-2,2);

        this.opacity =
        random(0.4,1);


        this.seed =
        Math.random()*9999;

    }

    update(time){

        this.speedX +=
        wind.strength*0.02;

        this.x += this.speedX;

        this.y += this.speedY;

        this.rotation +=
        this.rotationSpeed;
        if(atmosphere==="sparkle"){

    this.opacity =
        0.35 +
        (
            Math.sin(
                time*0.005+
                this.seed
            )+1
        )*0.325;

}
        const d =
        distance(
            this.x,
            this.y,
            mouse.x,
            mouse.y
        );

        if(d<mouse.radius){

            const angle =
            Math.atan2(
                this.y-mouse.y,
                this.x-mouse.x
            );

            this.x +=
            Math.cos(angle)*2;

            this.y +=
            Math.sin(angle)*2;

        }

        if(
            this.y>height+60 ||
            this.x<-80 ||
            this.x>width+80
        ){

            this.reset();

        }

    }

    draw(){

        ctx.save();

        ctx.translate(
            this.x,
            this.y
        );

        ctx.rotate(
            this.rotation*
            Math.PI/180
        );

        ctx.globalAlpha =
        this.opacity;

        /*
        Draw Function

        Comes in Part 2
        */

        drawParticle(
    atmosphere,
    this.size,
    this,
    performance.now()
);

        ctx.restore();

    }

}

/*==================================================
=            POOL
==================================================*/

const particles=[];

for(
let i=0;
i<settings.particles;
i++
){

particles.push(
new Particle()
);

}
/*==================================================
=            DRAW PARTICLES
==================================================*/

function drawParticle(type, size, particle, time) {

    switch(type){

        case "sakura":
            drawSakura(size);
            break;

        case "flower":
            drawFlower(size);
            break;

        case "butterfly":
            drawButterfly(size, particle, time);
            break;

        case "leaf":
    drawLeaf(size, particle, time);
    break;

case "sparkle":
    drawSparkle(size, particle, time);
    break;

default:
    drawDust(size, particle, time);

    }

}


/*==================================================
=            SAKURA
==================================================*/

function drawSakura(size) {

    const petalWidth = size * 0.55;
    const petalHeight = size;

    ctx.save();

    // Draw 5 petals
    for (let i = 0; i < 5; i++) {

        ctx.rotate((Math.PI * 2) / 5);

        const gradient = ctx.createLinearGradient(
            0,
            -petalHeight,
            0,
            petalHeight
        );

        gradient.addColorStop(0, "#ffd9e7");
        gradient.addColorStop(0.45, "#ffc1d6");
        gradient.addColorStop(1, "#f7a8c2");

        ctx.fillStyle = gradient;

        ctx.beginPath();

        ctx.moveTo(0, 0);

        ctx.bezierCurveTo(
            petalWidth,
            -petalHeight * 0.15,

            petalWidth,
            -petalHeight * 0.95,

            0,
            -petalHeight
        );

        ctx.bezierCurveTo(

            -petalWidth,
            -petalHeight * 0.95,

            -petalWidth,
            -petalHeight * 0.15,

            0,
            0

        );

        ctx.fill();

    }

    // Center

    ctx.fillStyle = "#ffe87a";

    ctx.beginPath();

    ctx.arc(
        0,
        0,
        size * 0.12,
        0,
        Math.PI * 2
    );

    ctx.fill();

    // Small pollen dots

    ctx.fillStyle = "#d8879f";

    for (let i = 0; i < 6; i++) {

        const angle =
            (Math.PI * 2 / 6) * i;

        ctx.beginPath();

        ctx.arc(
            Math.cos(angle) * size * 0.18,
            Math.sin(angle) * size * 0.18,
            size * 0.025,
            0,
            Math.PI * 2
        );

        ctx.fill();

    }

    ctx.restore();

}


/*==================================================
=            FLOWER
==================================================*/

function drawFlower(size) {

    const petalWidth = size * 0.45;
    const petalHeight = size * 0.9;

    ctx.save();

    for (let i = 0; i < 6; i++) {

        ctx.rotate(Math.PI / 3);

        ctx.fillStyle = "#ffd4e6";

        ctx.beginPath();

        ctx.ellipse(
            0,
            -petalHeight * 0.55,
            petalWidth,
            petalHeight * 0.45,
            0,
            0,
            Math.PI * 2
        );

        ctx.fill();

    }

    ctx.fillStyle = "#ffd84d";

    ctx.beginPath();

    ctx.arc(
        0,
        0,
        size * 0.18,
        0,
        Math.PI * 2
    );

    ctx.fill();

    ctx.restore();

}

/*==================================================
=            LOOP
==================================================*/

function animate(time){

    if(paused){

        requestAnimationFrame(
            animate
        );

        return;

    }

    updateWind(time);

    ctx.clearRect(
        0,
        0,
        width,
        height
    );

    for(const p of particles){

        p.update(time);

        p.draw();

    }

    requestAnimationFrame(
        animate
    );

}


/*==================================================
=            BUTTERFLY
==================================================*/

function drawButterfly(size, particle, time){

    const flap =
        Math.sin(
            time * 0.012 +
            particle.seed
        ) * 0.55;

    ctx.save();

    //----------------------------
    // Left Upper Wing
    //----------------------------

    ctx.save();

    ctx.rotate(-flap);

    let grad =
    ctx.createLinearGradient(
        -size,
        0,
        0,
        0
    );

    grad.addColorStop(0,"#ff9fd2");
    grad.addColorStop(1,"#ffd4f0");

    ctx.fillStyle = grad;

    ctx.beginPath();

    ctx.moveTo(0,0);

    ctx.bezierCurveTo(
        -size*0.9,
        -size*0.8,

        -size*1.2,
        size*0.2,

        0,
        size*0.15
    );

    ctx.closePath();

    ctx.fill();

    ctx.restore();

    //----------------------------
    // Right Upper Wing
    //----------------------------

    ctx.save();

    ctx.rotate(flap);

    grad =
    ctx.createLinearGradient(
        size,
        0,
        0,
        0
    );

    grad.addColorStop(0,"#ff9fd2");
    grad.addColorStop(1,"#ffd4f0");

    ctx.fillStyle = grad;

    ctx.beginPath();

    ctx.moveTo(0,0);

    ctx.bezierCurveTo(

        size*0.9,
        -size*0.8,

        size*1.2,
        size*0.2,

        0,
        size*0.15

    );

    ctx.closePath();

    ctx.fill();

    ctx.restore();

    //----------------------------
    // Lower Left Wing
    //----------------------------

    ctx.save();

    ctx.rotate(-flap*0.6);

    ctx.fillStyle="#ffb9de";

    ctx.beginPath();

    ctx.moveTo(0,0);

    ctx.quadraticCurveTo(
        -size*0.8,
        size*0.5,

        0,
        size*0.8
    );

    ctx.quadraticCurveTo(
        -size*0.25,
        size*0.4,

        0,
        0
    );

    ctx.fill();

    ctx.restore();

    //----------------------------
    // Lower Right Wing
    //----------------------------

    ctx.save();

    ctx.rotate(flap*0.6);

    ctx.fillStyle="#ffb9de";

    ctx.beginPath();

    ctx.moveTo(0,0);

    ctx.quadraticCurveTo(

        size*0.8,
        size*0.5,

        0,
        size*0.8

    );

    ctx.quadraticCurveTo(

        size*0.25,
        size*0.4,

        0,
        0

    );

    ctx.fill();

    ctx.restore();

    //----------------------------
    // Body
    //----------------------------

    ctx.fillStyle="#59342d";

    ctx.beginPath();

    ctx.roundRect(
        -size*0.07,
        -size*0.55,
        size*0.14,
        size*1.1,
        size*0.05
    );

    ctx.fill();

    //----------------------------
    // Head
    //----------------------------

    ctx.beginPath();

    ctx.arc(
        0,
        -size*0.65,
        size*0.10,
        0,
        Math.PI*2
    );

    ctx.fill();

    //----------------------------
    // Antenna
    //----------------------------

    ctx.strokeStyle="#59342d";

    ctx.lineWidth=1;

    ctx.beginPath();

    ctx.moveTo(
        0,
        -size*0.7
    );

    ctx.quadraticCurveTo(
        -size*0.15,
        -size*0.95,
        -size*0.30,
        -size
    );

    ctx.moveTo(
        0,
        -size*0.7
    );

    ctx.quadraticCurveTo(
        size*0.15,
        -size*0.95,
        size*0.30,
        -size
    );

    ctx.stroke();

    ctx.restore();

}
/*==================================================
=            LEAF
==================================================*/

function drawLeaf(size, particle, time){

    const bend =
        Math.sin(
            time * 0.002 +
            particle.seed
        ) * 0.25;

    ctx.save();

    ctx.rotate(bend);

    //----------------------------
    // Leaf Gradient
    //----------------------------

    const gradient =
        ctx.createLinearGradient(
            0,
            -size,
            0,
            size
        );

    gradient.addColorStop(0,"#cfe88d");
    gradient.addColorStop(.45,"#8ec96b");
    gradient.addColorStop(1,"#5b8f3d");

    ctx.fillStyle = gradient;

    //----------------------------
    // Leaf Shape
    //----------------------------

    ctx.beginPath();

    ctx.moveTo(
        0,
        -size
    );

    ctx.bezierCurveTo(

        size*.75,
        -size*.45,

        size*.45,
        size*.9,

        0,
        size

    );

    ctx.bezierCurveTo(

        -size*.45,
        size*.9,

        -size*.75,
        -size*.45,

        0,
        -size

    );

    ctx.fill();

    //----------------------------
    // Center Vein
    //----------------------------

    ctx.strokeStyle="#467030";

    ctx.lineWidth=1.4;

    ctx.beginPath();

    ctx.moveTo(
        0,
        -size*.85
    );

    ctx.lineTo(
        0,
        size*.85
    );

    ctx.stroke();

    //----------------------------
    // Side Veins
    //----------------------------

    ctx.lineWidth=.8;

    for(let i=1;i<=5;i++){

        const y =
            -size*.7 +
            i*(size*.3);

        ctx.beginPath();

        ctx.moveTo(
            0,
            y
        );

        ctx.lineTo(
            size*.28,
            y-size*.12
        );

        ctx.stroke();

        ctx.beginPath();

        ctx.moveTo(
            0,
            y
        );

        ctx.lineTo(
            -size*.28,
            y-size*.12
        );

        ctx.stroke();

    }

    //----------------------------
    // Stem
    //----------------------------

    ctx.strokeStyle="#6f5135";

    ctx.lineWidth=2;

    ctx.beginPath();

    ctx.moveTo(
        0,
        size
    );

    ctx.lineTo(
        0,
        size*1.25
    );

    ctx.stroke();

    ctx.restore();

}

/*==================================================
=            SPARKLE
==================================================*/

function drawSparkle(size, particle, time){

    const pulse =
        0.65 +
        (
            Math.sin(
                time * 0.006 +
                particle.seed
            ) + 1
        ) * 0.35;

    const rotate =
        time * 0.0005 +
        particle.seed;

    ctx.save();

    ctx.rotate(rotate);

    //-------------------------
    // Glow
    //-------------------------

    ctx.shadowColor = "#fff8da";
    ctx.shadowBlur = size * 2.5;

    //-------------------------
    // Main Star
    //-------------------------

    ctx.fillStyle = "#fffbe8";

    ctx.beginPath();

    for(let i=0;i<8;i++){

        const angle =
            i * Math.PI / 4;

        const radius =
            i % 2 === 0
            ? size * pulse
            : size * 0.35 * pulse;

        const x =
            Math.cos(angle) * radius;

        const y =
            Math.sin(angle) * radius;

        if(i===0)
            ctx.moveTo(x,y);
        else
            ctx.lineTo(x,y);

    }

    ctx.closePath();

    ctx.fill();

    //-------------------------
    // Inner Glow
    //-------------------------

    ctx.beginPath();

    ctx.fillStyle="rgba(255,255,255,.95)";

    ctx.arc(
        0,
        0,
        size*.22*pulse,
        0,
        Math.PI*2
    );

    ctx.fill();

    //-------------------------
    // Outer Ring
    //-------------------------

    ctx.strokeStyle="rgba(255,255,255,.25)";

    ctx.lineWidth=1;

    ctx.beginPath();

    ctx.arc(
        0,
        0,
        size*.9*pulse,
        0,
        Math.PI*2
    );

    ctx.stroke();

    ctx.restore();

}




requestAnimationFrame(
animate
);

})();
